var o=(process.env.NODE_ENV==="test",console);export{o as logger};
